import { Configuration, PublicClientApplication } from '@azure/msal-browser';
import { configService } from './configService';

export interface MSALConfig {
  clientId: string;
  authority: string;
  redirectUri: string;
  scopes: string[];
}

let msalInstance: PublicClientApplication | null = null;

// Get MSAL configuration from centralized config service
export const getMSALConfig = (): Configuration => {
  const config = configService.getMSALConfig();
  
  return {
    auth: {
      clientId: config.clientId,
      authority: config.authority,
      redirectUri: config.redirectUri || window.location.origin,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  };
};

// Initialize MSAL instance
export const initializeMSAL = async (): Promise<PublicClientApplication> => {
  if (!msalInstance) {
    const configuration = getMSALConfig();
    msalInstance = new PublicClientApplication(configuration);
    await msalInstance.initialize();
  }
  return msalInstance;
};

// Get MSAL instance
export const getMSALInstance = (): PublicClientApplication | null => {
  return msalInstance;
};

// Get login request configuration
export const getLoginRequest = () => {
  const config = configService.getMSALConfig();
  return {
    scopes: config.scopes,
    prompt: 'select_account',
  };
};